import { differenceInDays } from "date-fns";

export function getDaysUntilDrawClose(scheduledCloseDate: Date) {
  return Math.max(
    Math.floor(differenceInDays(scheduledCloseDate, new Date())),
    1
  );
}
